import * as actionTypes from './actionTypes';
import type { EventLog } from './types';

/*------------------------------------------------------------------------------------------------*/
/* EventsLog Fetch Actions                                                                             */
/*------------------------------------------------------------------------------------------------*/
export const fetchEventsLogRequest = () => ({
  type: actionTypes.FETCH_EVENTS_LOG_REQUEST,
});

export const fetchEventsLogResponse = (response: EventLog[]) => ({
  type: actionTypes.FETCH_EVENTS_LOG_RESPONSE,
  response,
});
